import $ from "jquery";
// import Swiper JS
import Swiper, { Navigation, Pagination, Scrollbar } from 'swiper';
// import Swiper styles
import 'swiper/swiper-bundle.css';

// configure Swiper to use modules
Swiper.use([Navigation, Pagination, Scrollbar]);

$('.products_slider_db49__slider').each(function(){
  var $slider = $(this);

  new Swiper($slider[0], {
    slidesPerView: 2,
    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 3,
      }
    }  
  });
});



$('.products_slider_db49__product_text a.link').on('mouseenter', function(){
  // console.log('sdjflksjd');
  var $prev = $(this).parent().prev();
  $prev.addClass('active');
});

$('.products_slider_db49__product_text a.link').on('mouseleave', function(){
  // console.log('sdjflksjd2');
  var $prev = $(this).parent().prev();
  $prev.removeClass('active');
});

$('.products_ce12__product_text a.link').on('mouseenter', function(){
  var $prev = $(this).parent().prev();
  $prev.addClass('active');
});


$('.products_ce12__product_text a.link').on('mouseleave', function(){
  var $prev = $(this).parent().prev();
  $prev.removeClass('active');
});
